export const PASS3_SUPPORTS = Object.freeze([
  Object.freeze({ id: 'support-upper-left', x: 279, y: 286, w: 162, h: 225, depth: 4 }),
  Object.freeze({ id: 'support-upper-right', x: 500, y: 286, w: 162, h: 225, depth: 4 }),
  Object.freeze({ id: 'support-mid-left', x: 274, y: 494, w: 152, h: 231, depth: 6 }),
  Object.freeze({ id: 'support-mid-right', x: 515, y: 494, w: 152, h: 231, depth: 6 }),
  Object.freeze({ id: 'support-lower-left', x: 296, y: 872, w: 139, h: 109, depth: 6 }),
  Object.freeze({ id: 'support-lower-right', x: 506, y: 872, w: 139, h: 109, depth: 6 }),
]);

export const PASS3_RIVETS = Object.freeze([
  Object.freeze({ id: 'rivet-tl-a', x: 171, y: 196 }),
  Object.freeze({ id: 'rivet-tr-a', x: 769, y: 196 }),
  Object.freeze({ id: 'rivet-tl-b', x: 181, y: 287 }),
  Object.freeze({ id: 'rivet-tr-b', x: 760, y: 287 }),
  Object.freeze({ id: 'rivet-bl-a', x: 177, y: 905 }),
  Object.freeze({ id: 'rivet-br-a', x: 764, y: 905 }),
  Object.freeze({ id: 'rivet-bl-b', x: 181, y: 1001 }),
  Object.freeze({ id: 'rivet-br-b', x: 760, y: 1001 }),
]);

const ART_W = 941;
const ART_H = 1672;

function pct(value, total) {
  return `${(value / total) * 100}%`;
}

function supportNode(spec) {
  const node = document.createElement('div');
  node.className = 'bf-pass3-support';
  node.dataset.pass3Support = spec.id;
  node.setAttribute('aria-hidden', 'true');
  Object.assign(node.style, {
    left: pct(spec.x, ART_W),
    top: pct(spec.y, ART_H),
    width: pct(spec.w, ART_W),
    height: pct(spec.h, ART_H),
    zIndex: String(spec.depth),
  });
  return node;
}

function rivetNode(spec) {
  const node = document.createElement('span');
  node.className = 'bf-pass3-rivet';
  node.dataset.pass3Rivet = spec.id;
  node.setAttribute('aria-hidden', 'true');
  Object.assign(node.style, {
    left: pct(spec.x, ART_W),
    top: pct(spec.y, ART_H),
  });
  return node;
}

export function applyGameplayArtPass3(stage) {
  if (!stage || stage.dataset.parityPass3Applied === 'true') return;
  stage.dataset.parityPass3Applied = 'true';

  const shell = stage.querySelector('.bf-board-shell');
  if (!shell) return;

  ['support-left', 'support-right'].forEach((id) => {
    stage.querySelector(`[data-object-id="${id}"]`)?.classList.add('bf-pass3-replaced');
  });

  PASS3_SUPPORTS.forEach((spec) => shell.append(supportNode(spec)));
  PASS3_RIVETS.forEach((spec) => shell.append(rivetNode(spec)));
}
